import { IconButton, Modal } from '@workramp/ui';
import styled from 'styled-components';
import { Z_INDEX_LAYERS } from '~/constants';

const IMAGE_PADDING = 40;

export const StyledModal = styled(Modal)`
  border-radius: 0;
  max-width: calc(100% - ${(props) => props.theme.spacing(IMAGE_PADDING)}px);
  max-height: calc(100% - ${(props) => props.theme.spacing(IMAGE_PADDING)}px);
  width: auto;
`;

export const StyledCloseButton = styled(IconButton)`
  position: fixed;
  top: ${(props) => props.theme.spacing(6)}px;
  right: ${(props) => props.theme.spacing(6)}px;
  z-index: ${Z_INDEX_LAYERS.modals};
  color: ${(props) => props.theme.colors.on[0]};
`;
